import { useContext } from 'react';
import { InfoCardContext } from '../hooks/useInfoCard';

export function InfoCardSubhead() {
	const { isFullModeStyle, textPosition, subhead, handles } = useContext(InfoCardContext);

	if (!subhead) return null;

	function renderTokens(): string {
		const textAlignToken = textPosition === 'right' ? 'tr' : textPosition === 'left' ? 'tl' : 'tc';

		if (isFullModeStyle) {
			return textAlignToken;
		}

		return 'tl';
	}

	function renderStyles() {
		return { display: 'contents' };
	}

	return (
		<div className={`${handles.infoCardSubhead} t-body mt6 c-on-base ${renderTokens()} mw-100`}>
			<div style={renderStyles()}>{subhead}</div>
		</div>
	);
}
